import { Table } from 'antd';
import dayjs from 'dayjs';
import { capitalizeFirstLetter, minutesToTimeString } from 'utils/utils';
import styles from './index.module.scss';
import { EditActionSvg } from 'utils/svgs';
import { useContext } from 'react';
import { PermissionContext } from 'components/Global/AuthLayout';

const { Column } = Table;

type Props = {
	shiftData: any;
	isLoading: boolean;
	editDrawerHandler: any;
};

const ShiftTable = (props: Props) => {
	const { shiftData, isLoading, editDrawerHandler } = props;
	const permissions = useContext(PermissionContext);

	const isEditPermission =
		permissions.allowedPermissions.includes('Edit_Shift_Master');
	return (
		<div className={styles['dynamic-table']}>
			<Table
				dataSource={shiftData}
				scroll={{ y: 'calc(100vh - 360px)' }}
				rowKey={(record) => record.id}
				loading={isLoading}
				pagination={false}
			>
				<Column
					title="Shift Name"
					dataIndex="shiftName"
					key="name"
					className="bg-white"
					width="20%"
				/>
				<Column
					title="Type"
					dataIndex="shiftType"
					key="shiftType"
					className="bg-white"
					width="10%"
					render={(record: any, data: any) => {
						return (
							<>{capitalizeFirstLetter(data.shiftType) || '-'}</>
						);
					}}
				/>
				<Column
					title="Start Time"
					dataIndex="startTime"
					key="startTime"
					className="bg-white"
					width="15%"
					render={(record: any, data: any) => {
						return (
							<>{`${dayjs(data.startTime).format(
								'hh : mm A'
							)}`}</>
						);
					}}
				/>
				<Column
					title="End Time"
					dataIndex="endTime"
					key="endTime"
					className="bg-white"
					width="15%"
					render={(record: any, data: any) => {
						return (
							<>{`${dayjs(data.endTime).format('hh : mm A')}`}</>
						);
					}}
				/>
				<Column
					title="Regular Hours"
					dataIndex="defaultRegularHours"
					key="standardHours"
					className="bg-white"
					width="25%"
					render={(record: any, data: any) => {
						return (
							<>{minutesToTimeString(data.defaultRegularHours)}</>
						);
					}}
				/>
				<Column
					title="Overtime Hours"
					dataIndex="defaultOverTimeHours"
					key="standOverTime"
					className="bg-white"
					width="25%"
					render={(record: any, data: any) => {
						return (
							<>
								{minutesToTimeString(data.defaultOverTimeHours)}
							</>
						);
					}}
				/>
				{isEditPermission && (
					<Column
						title="Action"
						dataIndex="action"
						key="action"
						className="bg-white"
						width={'10%'}
						render={(record: any, data: any) => {
							return (
								<div
									style={{
										display: 'flex',
										gap: '2rem',
										alignItems: 'center',
									}}
								>
									{isEditPermission ? (
										<div
											className="cursor-pointer  flex align-center justify-center"
											onClick={() => {
												editDrawerHandler(data);
											}}
										>
											<EditActionSvg />
										</div>
									) : (
										<div className="cursor-not-allowed  flex align-center justify-center">
											<EditActionSvg color="#928F8F" />
										</div>
									)}
								</div>
							);
						}}
					/>
				)}
			</Table>
		</div>
	);
};

export default ShiftTable;
